module.exports = __webpack_public_path__ + "img/T_man.6c739954.png";